/**
 * @fileoverview Zod schemas for product tags (matches backend TagDTO / ProductSummaryDTO).
 * @module features/tags/schemas/tagSchema
 */
import { z } from 'zod'

export const tagSchema = z.object({
  uuid: z.string().uuid(),
  name: z.string(),
  slug: z.string(),
  productCount: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
})
export type Tag = z.infer<typeof tagSchema>

export const productSummarySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  imageUrl: z.string().nullable().optional(),
})
export type ProductSummary = z.infer<typeof productSummarySchema>
